module.exports = __webpack_public_path__ + "static/media/1578lex.76eb0338.jpg";